import React from 'react';
import {
  Show,
  SimpleShowLayout,
  ReferenceManyField,
  ReferenceField,
  Datagrid,
  TextField,
  NumberField,
  DateField,
  EditButton,
  ShowButton,
  DeleteButton,
  Button,
} from 'react-admin';
import { Link } from 'react-router-dom';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import VideoCallIcon from '@material-ui/icons/VideoCall';

export default (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField disabled label="Id" source="id" />
      <TextField source="name" />
      <NumberField source="order" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
      <ReferenceField
        label="Event"
        source="eventId"
        reference="Event"
        link="show"
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField
        label="Brand"
        source="brandId"
        reference="Brand"
        link="show"
      >
        <TextField source="name" />
      </ReferenceField>
      <LiveStreamReferenceManyField
        label="LiveStream"
        reference="LiveStream"
        target="listLiveStreamsByBooth"
      />
      <ReferenceManyField
        label="Activities"
        reference="BoothActivity"
        target="listActivitiesByBooth"
      >
        <Datagrid source="activity">
          <TextField source="activity.name" label="Name" />
          <TextField source="activity.summary" label="Summary" />
          <DateField
            source="activity.startingAt"
            label="Starting at"
            showTime
          />
          <DateField source="activity.endingAt" label="Ending at" showTime />
          <EditButton label="Reconnect" />
          <ShowActivityButton />
          <DeleteButton label="Disconnect" />
        </Datagrid>
      </ReferenceManyField>
      <AddActivityButton />
      <ConnectActivityButton />
    </SimpleShowLayout>
  </Show>
);

const LiveStreamReferenceManyField = (props) => (
  <ReferenceManyField {...props}>
    <SingleLiveStreamDatagrid record={props.record} />
  </ReferenceManyField>
);

LiveStreamReferenceManyField.defaultProps = {
  label: 'Livestream',
  addLabel: true,
};

const SingleLiveStreamDatagrid = (props) =>
  !!props.ids && !!props.ids.length ? (
    <Datagrid>
      <TextField source="name" />
      <EditButton />
      <ShowButton />
      <DeleteButton />
    </Datagrid>
  ) : (
    <AddNewLiveStreamButton record={props.record} />
  );

const ShowActivityButton = ({ record, ...rest }) => {
  return <ShowButton {...rest} basePath="/Activity" record={record.activity} />;
};

const AddActivityButton = ({ record }) => (
  <Button
    component={Link}
    to={{
      pathname: '/Activity/create',
      state: { record: { eventId: record.eventId } },
    }}
    label="Add an activity (Connect activity after adding)"
  >
    <CalendarTodayIcon />
  </Button>
);

const ConnectActivityButton = ({ record }) => (
  <Button
    component={Link}
    to={{
      pathname: '/BoothActivity/create',
      state: { record: { boothId: record.id } },
    }}
    label="Connect activity"
  >
    <CalendarTodayIcon />
  </Button>
);

const AddNewLiveStreamButton = ({ record }) => (
  <Button
    component={Link}
    to={{
      pathname: '/LiveStream/create',
      state: { record: { boothId: record.id, name: record.name } },
    }}
    label="Add a live stream"
  >
    <VideoCallIcon />
  </Button>
);
